<template>
    <div class="col-md-7 col-lg-8 block_left_product pl-3 pl-lg-0">



        <agile class="main" ref="main" :options="options1" :as-nav-for="asNavFor1" @after-change="e => currentSlide = e.currentSlide">
            <div class="slide" v-for="(slide, index) in slides" :key="index" :class="`slide--${index}`">
                <img :src="slide.url" class="image-product-detail" alt="image-product-detail" />
            </div>

            <template slot="caption">
                <b>Imagen compartida por:</b><br/>
                {{ slides[currentSlide]["by"] }}
            </template>
        </agile>
        <agile class="thumbnails" ref="thumbnails" :slides-to-show="howManyShow" :options="options2" :as-nav-for="asNavFor2">
            <div class="slide slide--thumbniail" v-for="(slide, index) in slides" :key="index" :class="`slide--${index}`" @click="$refs.thumbnails.goTo(index)">
                <img :src="slide.url" alt="slide-url" />
            </div>
            <template slot="prevButton">
<!--                <i class="fas fa-chevron-left"></i>-->
                <div data-v-64ccd32b="" class="swiper-button-prev " tabindex="0" role="button" aria-label="Previous slide" aria-disabled="true"></div>
            </template>
            <template slot="nextButton">
                <div data-v-64ccd32b="" class="swiper-button-next " tabindex="0" role="button" aria-label="Previous slide" aria-disabled="true"></div>
            </template>
        </agile>

    </div>
</template>

<script>
    import { VueAgile } from 'vue-agile';
    import "vue-agile/dist/VueAgile.css";

    export default {
        name: "ImageProductComponent",
        props: ["articulo"],
        components: {
            agile: VueAgile
        },
        data: function(){
            return {
                // thumbs: [],
                // images: [],
                // imgSelected: this.articulo.img_verify,
                // by: "Babyplant"

                currentSlide: 0,
                asNavFor1: [],
                asNavFor2: [],
                options1: {
                    dots: false,
                    fade: true,
                    navButtons: false
                },

                options2: {
                    autoplay: false,
                    centerMode: true,
                    dots: false,
                    navButtons: false,
                    // slidesToShow: 3,
                    responsive: [
                        {
                            breakpoint: 600,
                            settings: {
                                // slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 1000,
                            settings: {
                                navButtons: true
                            }
                        }
                    ]

                },
                // slides:[]

                slides: [
                    // 'https://images.unsplash.com/photo-1453831362806-3d5577f014a4?ixlib=rb-1.2.1&q=85&fm=jpg&crop=entropy&cs=srgb&w=1600&fit=max&ixid=eyJhcHBfaWQiOjE0NTg5fQ',
                    // 'https://images.unsplash.com/photo-1496412705862-e0088f16f791?ixlib=rb-1.2.1&q=85&fm=jpg&crop=entropy&cs=srgb&w=1600&fit=max&ixid=eyJhcHBfaWQiOjE0NTg5fQ',
                    // 'https://images.unsplash.com/photo-1506354666786-959d6d497f1a?ixlib=rb-1.2.1&q=85&fm=jpg&crop=entropy&cs=srgb&w=1600&fit=max&ixid=eyJhcHBfaWQiOjE0NTg5fQ',
                    // 'https://images.unsplash.com/photo-1455619452474-d2be8b1e70cd?ixlib=rb-1.2.1&q=85&fm=jpg&crop=entropy&cs=srgb&w=1600&fit=max&ixid=eyJhcHBfaWQiOjE0NTg5fQ',
                    // 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?ixlib=rb-1.2.1&q=85&fm=jpg&crop=entropy&cs=srgb&w=1600&fit=max&ixid=eyJhcHBfaWQiOjE0NTg5fQ',
                    // 'https://images.unsplash.com/photo-1472926373053-51b220987527?ixlib=rb-1.2.1&q=85&fm=jpg&crop=entropy&cs=srgb&w=1600&fit=max&ixid=eyJhcHBfaWQiOjE0NTg5fQ',
                    // 'https://images.unsplash.com/photo-1497534547324-0ebb3f052e88?ixlib=rb-1.2.1&q=85&fm=jpg&crop=entropy&cs=srgb&w=1600&fit=max&ixid=eyJhcHBfaWQiOjE0NTg5fQ'
                ]
            }

        },
        methods:{
            changeSlide: function(e){
                console.log(e);
            },
        },
        computed:{
            howManyShow: function () {
                if(this.slides.length > 4){
                    return 4;
                }else{
                    return this.slides.length;
                }
            }
        },
        created() {

            // this.thumbs.push({url: this.articulo.img_verify, by: "Babyplant"});
            this.slides.push({url: this.articulo.img_verify, by: "Babyplant Store"});

            this.articulo.informacion_adicional.forEach((el) => {
                // this.thumbs.push({url: el.url_media_thumb, by: el.nombre});
                this.slides.push({url: el.url_media, by: el.nombre});
            });


        },
        mounted() {
            this.asNavFor1.push(this.$refs.thumbnails);
            this.asNavFor2.push(this.$refs.main);
        }
    }
</script>

<style >


    /*#app {*/
    /*    font-family: "Lato", sans-serif;*/
    /*    font-weight: 300;*/
    /*    margin: 0 auto;*/
    /*    max-width: 900px;*/
    /*    padding: 30px;*/
    /*}*/

    .main {
        margin-bottom: 30px;
    }

    .thumbnails {
        margin: 0 -5px;
        width: calc(100% + 10px);
    }

    .agile__nav-button {
        background: transparent;
        border: none;
        color: #ccc;
        cursor: pointer;
        font-size: 24px;
        -webkit-transition-duration: 0.3s;
        transition-duration: 0.3s;
    }
    .thumbnails .agile__nav-button {
        position: absolute;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .thumbnails .agile__nav-button--prev {
        left: 3px;
    }
    .thumbnails .agile__nav-button--next {
        right: 6px;
    }
    .agile__nav-button:hover {
        color: #888;
    }
    .agile__dot {
        margin: 0 10px;
    }
    .agile__dot button {
        background-color: #eee;
        border: none;
        border-radius: 50%;
        cursor: pointer;
        display: block;
        height: 10px;
        font-size: 0;
        line-height: 0;
        margin: 0;
        padding: 0;
        -webkit-transition-duration: 0.3s;
        transition-duration: 0.3s;
        width: 10px;
    }
    .agile__dot--current button, .agile__dot:hover button {
        background-color: #888;
    }

    .slide {
        -webkit-box-align: center;
        align-items: center;
        box-sizing: border-box;
        color: #fff;
        display: -webkit-box;
        display: flex;
        height: 450px;
        -webkit-box-pack: center;
        justify-content: center;
    }
    .slide--thumbniail {
        cursor: pointer;
        height: 100px;
        padding: 0 5px;
        -webkit-transition: opacity 0.3s;
        transition: opacity 0.3s;
    }
    .slide--thumbniail:hover {
        opacity: 0.75;
    }
    .slide img {
        height: 100%;
        -o-object-fit: contain;
        object-fit: contain;
        -o-object-position: center;
        object-position: center;
        width: 100%;
    }


    /*.agile__actions{*/
    /*    margin-top: -20px;*/
    /*}*/

    #section_product_detail .block_left_product img{
        width: 100% !important;
        max-width: none;
    }

    .agile__caption{
        text-align: left;
        background-image: linear-gradient(to right, #e4e3e3 ,rgba(255, 255, 255, 0.1));
        padding: 5px;
        padding-left: 10px;
    }

    .swiper-button-prev, .swiper-button-next{
        border: 3px solid #0071bc;
        filter: none !important;
        -webkit-filter: none !important;
        opacity: unset;
        background-color: #fec82f !important;
        color: #f19000 !important;
        -webkit-box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.35);
        -moz-box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.35);
        box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.35);

    }

    /*.bottom-left {*/
    /*    !*position: absolute;*!*/
    /*    !*bottom: 8px;*!*/
    /*    left: 20%;*/
    /*    !*width:70%;*!*/
    /*    text-align: left;*/
    /*    padding: 5px;*/
    /*    background-color: #80808033;*/
    /*}*/
</style>
